import { arrayOf } from 'prop-types';
import { productShape } from 'shapes';

export default arrayOf(productShape);
